// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Ji1Q","footer":"Form_footer__1_tv3"};